import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported, logEvent } from "firebase/analytics";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId's is optional
const firebaseConfig = {
  apiKey: "AIzaSyBzKgu1F--8KjzHspOpVqJ-HtFgL5jNZqs",
  authDomain: "mathematise-31daf.firebaseapp.com",
  projectId: "mathematise-31daf",
  storageBucket: "mathematise-31daf.firebasestorage.app",
  messagingSenderId: "99905743470",
  appId: "1:99905743470:web:09a7d7459d742330b3147f",
  measurementId: "G-FQ0MZ7ZDE8"
};

const app = initializeApp(firebaseConfig);

let analyticsPromise = null;

export const initAnalytics = () => {
  if (analyticsPromise) {
    return analyticsPromise;
  }

  analyticsPromise = isSupported().then((supported) => {
    if (!supported) {
      return null;
    }

    return getAnalytics(app);
  });

  return analyticsPromise;
};

export const logAnalyticsEvent = async (name, params = {}) => {
  const analytics = await initAnalytics();
  if (!analytics) {
    return;
  }

  logEvent(analytics, name, params);
};

export default app;
